import React from "react";

function About() {
  return (
    <div>
      <h1>About this project</h1>

      <h3>
        I made this project on my own. Goal of this project is to learn React
        redux toolkit.
      </h3>
      <h3>Work is still in progress....</h3>
    </div>
  );
}

export default About;
